import { ContactCardProps } from '@components/contact-card/ContactCard';

export interface ContactDataByMarket {
  california: ContactCardProps[];
  colorado: ContactCardProps[];
}

export const contactDataByMarket: ContactDataByMarket = {
  california: [
    {
      name: 'Ashleigh Stumler',
      title: 'Sales Director, California',
      phone: '858-215-2592',
      email: 'ashleigh@guesthouseshop.com',
      projectType: {
        label: 'For new projects',
        backgroundColor: '#E3F1D1',
      },
      avatarInitials: 'AS',
    },
    {
      name: 'Sandra Ghanem',
      title: 'General Manager, California',
      phone: '619-663-6437',
      email: 'sandra@guesthouseshop.com',
      projectType: {
        label: 'For existing projects',
        backgroundColor: '#D3E0E2',
      },
      avatarInitials: 'SG',
    },
  ],
  colorado: [
    {
      name: 'Sarah LeBuhn',
      title: 'Account Executive, Colorado',
      phone: '720-255-1683',
      email: 'sarah@guesthouseshop.com',
      projectType: {
        label: 'For new projects',
        backgroundColor: '#E3F1D1',
      },
      avatarInitials: 'SL',
    },
    {
      name: 'Ashley Luke',
      title: 'General Manager, Colorado',
      phone: '720-722-3059',
      email: 'ashley@guesthouseshop.com',
      projectType: {
        label: 'For existing projects',
        backgroundColor: '#D3E0E2',
      },
      avatarInitials: 'AL',
    },
  ],
};
